module.exports = __webpack_public_path__ + "img/t2-feature-text.e383cf88.png";